<template>
  <OrganismClearCache/>
</template>

<script>
export default {
  name: 'ClearCache',

  components: {
    OrganismClearCache: () => import('@/components/organisms/OrganismClearCache')
  }
}
</script>
